import { ManageEmailListsPage } from '@online-webinar/management';
import { RouterType } from '@online-webinar/router';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/manage/email-lists/'].update({
        staticData: { title: { page: 'EmailLists.PageHeading' } },
        component: authGuard(ManageEmailListsPage, { isWhitelabel: true, canManageEmailLists: true })
    });
};
